export var TypeActionPlayerInfo;
(function (TypeActionPlayerInfo) {
    TypeActionPlayerInfo["Received"] = "PlayerInfo > Received";
    TypeActionPlayerInfo["AddXp"] = "PlayerInfo > AddXp";
    TypeActionPlayerInfo["AddLevel"] = "PlayerInfo > AddLevel";
    TypeActionPlayerInfo["ChangeName"] = "PlayerInfo > ChangeName";
    TypeActionPlayerInfo["ChangeProfilePicture"] = "PlayerInfo > ChangeProfilePicture";
    TypeActionPlayerInfo["AddBuff"] = "PlayerInfo > AddBuff";
    TypeActionPlayerInfo["RemoveBuff"] = "PlayerInfo > RemoveBuff";
    TypeActionPlayerInfo["ExpiredBuff"] = "PlayerInfo > ExpiredBuff";
    TypeActionPlayerInfo["UpdateCoopInfo"] = "PlayerInfo  > UpdateCoopInfo";
})(TypeActionPlayerInfo || (TypeActionPlayerInfo = {}));
export var actionPlayerInfo = function (props) { return ({
    playerInfo: props,
    type: TypeActionPlayerInfo.Received,
}); };
export var actionPlayerInfoAddXp = function (xp) { return ({
    type: TypeActionPlayerInfo.AddXp,
    xp: xp,
}); };
export var actionPlayerInfoAddLevel = function (level) { return ({
    level: level,
    type: TypeActionPlayerInfo.AddLevel,
}); };
export var actionPlayerInfoChangeName = function (name) { return ({
    name: name,
    type: TypeActionPlayerInfo.ChangeName,
}); };
export var actionPlayerInfoChangeProfilePicture = function (id) { return ({
    id: id,
    type: TypeActionPlayerInfo.ChangeProfilePicture,
}); };
export var actionPlayerInfoAddBuffs = function (buff) { return ({
    buff: buff,
    type: TypeActionPlayerInfo.AddBuff,
}); };
export var actionPlayerInfoRemoveBuffs = function (buff) { return ({
    buff: buff,
    type: TypeActionPlayerInfo.RemoveBuff,
}); };
export var actionPlayerInfoUpdateCoopInfo = function (coopId) { return ({
    coopId: coopId,
    type: TypeActionPlayerInfo.UpdateCoopInfo,
}); };
export var actionPlayerInfoBuffExpire = function (buff, remainingTime) { return ({
    buff: buff,
    remainingTime: remainingTime,
    type: TypeActionPlayerInfo.ExpiredBuff,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player/actionPlayerInfo.ts
// module id = 44
// module chunks = 3